import React from 'react'
import { RouteProps } from 'react-router-dom'

import Dashboard from 'src/layouts/Dashboard'

import ProtectedRoute from './ProtectedRoute'

function DashboardRoute({ component: Component, ...rest }: RouteProps) {
  return (
    <ProtectedRoute
      {...rest}
      render={routeProps => (
        <Dashboard>
          <Component {...routeProps} />
        </Dashboard>
      )}
    />
  )
}

export default DashboardRoute
